import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, {
        email,
        password
      });
      
      localStorage.setItem("admin_token", response.data.token);
      localStorage.setItem("admin_email", response.data.email);
      toast.success("Ingelogd als beheerder");
      onLogin(response.data.token);
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Ongeldige inloggegevens");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[#121212] border border-white/10 rounded-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-serif text-brand-gold mb-2">BARBAAR</h1>
            <p className="text-gray-400">Backoffice Login</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label className="text-gray-300">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="reservatie@barbaarmiddelkerke.com"
                  className="bg-[#1A1A1A] border-white/20 pl-10 text-white"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label className="text-gray-300">Wachtwoord</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                <Input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-[#1A1A1A] border-white/20 pl-10 pr-10 text-white"
                  required
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-gold text-black hover:bg-[#F0C74A] font-semibold py-3"
              data-testid="admin-login-btn"
            >
              {loading ? "Inloggen..." : "Inloggen"}
            </Button>
          </form>

          <p className="text-center text-gray-500 text-sm mt-6">
            Alleen voor geautoriseerd personeel
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
